import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import classNames from "classnames";
// import Moment from "react-moment";
import Clock from "react-live-clock";
import RefreshIcon from "@material-ui/icons/Refresh";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import AppsIcon from '@material-ui/icons/Apps';
import MenuIcon from '@material-ui/icons/Menu';
import PhonelinkRingIcon from '@mui/icons-material/PhonelinkRing';
import  "./styles.css";
import {
    AppBar,
    Toolbar,
    IconButton,
    Menu,
    MenuItem,
    Tooltip,
    Link,
    Divider,
    Button,
    Box,
    Select,
    ListItemText,
} from "@material-ui/core";
import {
    NotificationsNone as NotificationsIcon,
    AccessTime as AccessTimeIcon,
} from "@material-ui/icons";
import LocalParkingOutlinedIcon from '@mui/icons-material/LocalParkingOutlined';
import { createTheme, MuiThemeProvider } from "@material-ui/core/styles";

// styles
import useStyles from "./styles";
import LogoIcon from "./Icons/LogoIcon";
import LogOutIcon from "./Icons/LogOutIcon";
import logoWhite from "../../assets/images/logowhitesm.webp";

// components

import SwitchMode from "./SwitchMode";
import SelectBreak from "./Break";
// import TimeZone from "./TimeZone";
import { Badge, Typography } from "../Wrappers/Wrapper";
import Notification from "../Notification/Notification";
import QueueCount from "../CallQueue/QueueCount";
import BreakButton from "../Break/BreakButton";
import WebrtcBox from "../Boxes/WebrtcBox";
import {
    localStorageFunc,
    lowerCaseAllWordsExceptFirstLetters,
    notify,
    LoadJs
} from "../../helpers/utility";

//store
import * as actions from "../../store/actions/actionIndex";
import PasswordReset from "../Modal/PasswordReset";
import ParkCount from "../CallPark/ParkCount";

const theme = createTheme({
    overrides: {
        MuiTooltip: {
            tooltip: {
                position: "absolute",
                left: "-10px",
                right: "1px",
                fontSize: "0.9em",
                color: "black",
                width: "200px",
                marginTop: "5px",
                marginBottom: "5px",
                backgroundColor: "white",
                border: "thin",
                boxShadow: "0px 0px 4px rgba(0,0,0,0.5)",
            },
        },
    },
});

function Header(props) {
    var classes = useStyles();
  const timeoutRef = useRef(null);

    var breakReasons = Array.from(props.breakReasons);
    const {
        agentId,
        onAgentNotification,
        onAgentConfig,
        onCallData,
        onGetDisposition,
        onBreakReason,
        agentConf,
        // timezones,
        autoReadyTime,
        onAgentBreak,
        autoReadyFlag,
        breakLoading,
        agentState,
        lastActivityTime,
        breakType,
    } = props;
    const [checked, setChecked] = React.useState(
        props.mode === "PROGRESSIVE" ? true : false
    );
    const [notificationsMenu, setNotificationsMenu] = useState(null);
    const [isNotificationsUnread, setIsNotificationsUnread] = useState(true);
    const [profileMenu, setProfileMenu] = useState(null);

    const [show, toggleShow] = useState(true);
    const [notificationCount, setNotificationCount] = useState(0);
    const autoAgentNotificationAction = useRef(null);
    const [callDataCount, setCallDataCount] = useState(0);
    const autoCallData = useRef(null);
    //const autoBreakAction = useRef(null);
    const autoReadyAction = useRef(null);
    const agentStateRef = useRef(props.agentState);
    var [value, setValue] = useState("null");
    const [selectedTimezone, setSelectedTimezone] = useState( props.AgentTimezone );
    const [resetOpen, setResetOpen] = useState(false);
     const [selectedGateway, setSelectedGateway] = React.useState('');
      const [gatewayList, setGatewayList] = React.useState([]);
      const [isSwitchDisabled, setIsSwitchDisabled] = useState(false);
       const[isMobileSelectOpen,setIsMobileSelectOpen] = useState(false);
 
const setTimezone = () => {
    setOpen(false);
};
 
const toggleSelectsParentDiv = () => {
    setIsMobileSelectOpen(!isMobileSelectOpen)
}

// Load Js File

useEffect(() => {
      if (props.campConf.campaign_id !== undefined) {
        LoadJs(`${window.Configs.scriptFile_path}/bc_${props.campConf.campaign_id}.js`);
      }
  }, [props.campConf.campaign_id]);


useEffect(() => {
    setSelectedTimezone(props.AgentTimezone);
}, [props.AgentTimezone]);


    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    useEffect(() => {
        clearTimeout(autoReadyAction.current);
      
        if (autoReadyFlag === "1" && agentState === "READY" && !breakLoading) {
          let counter = parseInt(autoReadyTime) - parseInt(lastActivityTime);
          counter = counter > 1 ? counter : 1;
          autoReadyAction.current = setTimeout(() => {
            onAgentBreak(agentId, "READY", breakType);
          }, counter * 1000);
        }
      
        return () => {
          clearTimeout(autoReadyAction.current);
        };
      }, [
        agentState
      ]);
      
      
      

    if (props.agentState !== "READY") {
        localStorageFunc.erase("autoReadyFlag");
        clearTimeout(window.autoReadyAction);
    }

    useEffect(
        () => {
            if (agentId) {
                onAgentNotification(agentId);
            }
            clearTimeout(autoAgentNotificationAction);
            autoAgentNotificationAction.current = setTimeout(function() {
                setNotificationCount(notificationCount + 1);
            }, 120000);
        },
        [agentId, onAgentNotification, notificationCount],
        []
    );

    useEffect(
        () => {
            if (agentId) {
                onCallData(agentId);
            }
            clearTimeout(autoCallData);
            autoCallData.current = setTimeout(function() {
                setCallDataCount(callDataCount + 1);
            }, 120000);
        },
        [agentId, onCallData, callDataCount],
        []
    );
    

    useEffect(
        () => {
            if (agentId && Object.keys(agentConf).length === 0) {
                onAgentConfig(agentId);
            }
            if (agentId) {
                onGetDisposition(agentId);
                onBreakReason(agentId);
            }
        },
        [agentId, onGetDisposition, onBreakReason, onAgentConfig, agentConf],
        []
    );

    useEffect(() => {
        const responseCode = localStorageFunc.get("responseCode");
        const reason = localStorageFunc.get("reason");

        if (responseCode === "2") {
            setIsNotificationsUnread(true);
            const newNotification = {
                id: Date.now(),
                message: (
                    <Box className="reset-dialog">
                        Password Expiration Notice: <br /> {reason}
                        <Button variant="outlined" onClick={handleResetPassword} style={{ marginLeft: '10px' }}>
                            Reset Password
                        </Button>
                    </Box>
                ),
            };
            notifications.push(newNotification);
        }
    }, []);

    const signOut = (history) => {
        if (
            props.agentState === "INCALL" ||
            props.agentState === "CLOSURE" ||
            props.agentState === "PREVIEW_FAIL"
        ) {
            notify("CRM Error: Please Disconnect the Call", "crm-error");
        } else {
            history.push("/logout");
        }
    };
    const handleChange = (event) => {
        if (isSwitchDisabled) return; 
    
        setIsSwitchDisabled(true);
    
        let mode = event.target.checked === false ? "PREVIEW" : "PROGRESSIVE";
    
        if (mode !== props.mode) {
            props.onModeChange(props.agentId, mode, props.agentState);
        }
    
        if (props.agentState === 'FREE') {
            setChecked(event.target.checked);
        }
    
        setTimeout(() => {
            setIsSwitchDisabled(false);
        }, 5000); 
    };
    
// automatically change Mode on given time

useEffect(() =>{
    if(props.dialerType === "PROGRESSIVE"){
            setChecked(true);
    }
    else{
        setChecked(false)
    }
},[props.dialerType, checked])

useEffect(() => {
    if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
    }

    if (
        props.dialerType === "PREVIEW" &&
        props.agentState === "FREE" &&
        props.campConf.auto_progressive_transfer === "1"
    ) {
        timeoutRef.current = setTimeout(() => {
            props.onModeChange(props.agentId, "PROGRESSIVE", props.agentState);
            setChecked(true);
        }, props.campConf.AP_autoProgressTransf * 1000);
    }
    return () => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
    };
}, [props.dialerType, props.agentState, props.campConf.auto_progressive_transfer]);
    

    const breakClicked = (value) => {
        if (props.agentState !== "BREAK") {
            setValue(value);
            props.onAgentBreak(props.agentId, "BREAK", value);
        }
    };
    const handleBreak = () => {
        props.onAgentBreak(
            props.agentId,
            props.agentState === "READY" ? "READY" : "FREE",
            props.breakType
        );
        localStorageFunc.set("autoBreakFlag", "autoBreakFlag", 10);
        localStorageFunc.erase("autoReadyFlag");
        clearTimeout(window.autoBreakAction);
        clearTimeout(window.autoReadyAction);
        setValue("null");
    };
    const handleRefresh = ()=>{
        window.location.reload(false)

    }
 
    const [notifications, setNotifications] = useState(Array.from(props.msgs));

useEffect(() => {
    agentStateRef.current = props.agentState;
    if(agentStateRef.current === "FREE"){
        setValue("null");
    }
  }, [props.agentState]);
  
  const handleResetPassword = () => {
    const currentAgentState = agentStateRef.current;
  
    if (
      currentAgentState === "INCALL" ||
      currentAgentState === "CLOSURE" ||
      currentAgentState === "PREVIEW_FAIL"
    ) {
      notify("Password Error: Please Disconnect the Call for Reset Password", "crm-error");
    } else if (currentAgentState === "FREE") {
      setResetOpen(true);
    }
  };
    const handleClose = () => {
        setResetOpen(false);
    };

    const prevModeRef = useRef();
//Gateway selection
const handleGatewayChange = (event) => {
    const selected = event.target.value;
    if(props.agentState !== "INCALL" &&
        props.agentState !== "CLOSURE" &&
        props.agentState !== "PREVIEW_FAIL"){
    setSelectedGateway(selected);
    localStorage.setItem("selected_gateway", selected);
    }
    else{
        notify("Error: Please disconnect the call before changing the gateway", "gateway-error");
    }
  };
useEffect(() => {
  const currentMode = props.mode;
  const gateways = props.campConf?.gateway_details?.[currentMode] || [];

  setGatewayList(gateways);

  const savedGateway = localStorage.getItem("selected_gateway");
  const gwDialing = props.campConf?.gw_dialing;
  const hasPrevModeChanged = prevModeRef.current && prevModeRef.current !== currentMode;

  if (gwDialing !== "1") {
    if (hasPrevModeChanged) {
      setSelectedGateway("");
      localStorage.removeItem("selected_gateway");
    } else if (savedGateway && gateways.some(g => (typeof g === "object" ? g.value === savedGateway : g === savedGateway))) {
      setSelectedGateway(savedGateway);
    } else {
      setSelectedGateway("");
    }
  } else {
    localStorage.removeItem("selected_gateway");
    setSelectedGateway("");
  }
  prevModeRef.current = currentMode;
}, [props.mode, props.campConf]);

  const onToggleSidebar = (isSidebarOpened) => {
        props.onToggle(isSidebarOpened);
    };

function webrtcRegistered (){
    if (props.loginType === "Webrtc" && props.registerstatus === "0")
        {
    const janusPort = localStorageFunc.get("janus_port") || "443";
        window.web_rt(
          props.agentId,
          localStorageFunc.get("sip"),
          localStorageFunc.get("reg_ip"),
          true,
          window.auto_answer_flag,
          localStorageFunc.get("secret"),
          localStorageFunc.get("janus_ip"),
          janusPort
        );
    }
}

useEffect(() =>{
    if(props.registerstatus === "0"){
        setTimeout(() =>{webrtcRegistered()},[3000])
    }
},[props.registerstatus])
    return (
        <AppBar className={classes.appBar}>
            <Toolbar className={classes.toolbar}>
                <WebrtcBox  callType = {props.callType}/>
                <Typography
                    variant="h6"
                    weight="medium"
                    className={classes.logotype}
                >
                    <MuiThemeProvider theme={theme}>
                        <Tooltip title="C-Zentrix Telephony Agent Panel">
                            <Link href="#" color="secondary">
                                <u className={classes.Remarks} style={{display:"flex"}}>
                                    <LogoIcon />
                                </u>
                            </Link>
                        </Tooltip>
                    </MuiThemeProvider>
                    <span>
                    &nbsp; Agent State -{" "}
                    {lowerCaseAllWordsExceptFirstLetters(
                        props.agentState.replace("_", " ")
                    )}
                    </span>
                </Typography>
               {/* ===== This Box is just for mobile view ===== */}
                 <Box sx={{display: {sm:"none"}}}>
                   <img src={logoWhite} alt="logo" width="40px" height="auto" />
                     </Box>
            <Box className={classes.headerTimeParent}>
                <div className={classes.timeIcon}>
                    <AccessTimeIcon className={classes.timeIconSvg}/>
                </div>
                

                <div className={classes.time}>
                    {/* <Moment format=" "></Moment> */}
                    <Clock
                        date={""}
                        format={"DD/MM/YYYY h:mm:ss A"}
                        timezone={selectedTimezone}
                        
                        ticking={true}
                    />
                </div>
                </Box>

                <div className={classes.grow} />
                 <div className={[classes.selectsParentDiv, !isMobileSelectOpen ? classes.hideSelectParent : ""].join(" ")}>
        <div style={{ display: 'flex', alignItems: 'center', marginRight: '20px', cursor: "pointer" }} onClick={webrtcRegistered}>
    {/* The Indicator Container */}
    <div style={{ 
        position: 'relative', 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center',
        marginRight: '10px' 
    }}>
        
        {/* Outer Glow Ring (Optional Pulse) */}
        <div style={{
            position: 'absolute',
            width: '16px',
            height: '16px',
            borderRadius: '50%',
            backgroundColor: props.registerstatus === "0" ? 'rgba(255, 23, 68, 0.2)' : 'rgba(99, 181, 0, 0.3)',
            transition: 'all 0.3s ease'
        }}  />
        {/* Inner Solid Circle */}
        <div style={{
            width: '10px',
            height: '10px',
            borderRadius: '50%',
            backgroundColor: props.registerstatus === "0" ? '#ff1744' : '#63b500',
            zIndex: 1,
            boxShadow: props.registerstatus === "0" ? 'none' : '0 0 8px #63b500'
        }} />
    </div>

    {/* Status Text - Clean & Subtle */}
    <Typography style={{ 
        fontSize: '14px', 
        fontWeight: '700', 
        color: props.registerstatus === "0" ? '#ff1744' : '#63b500',
        letterSpacing: '1px'
    }}>
        {props.registerstatus === "0" ? "OFFLINE" : "ONLINE"}
    </Typography>
</div>


                {props.agentState !== "READY" &&
                    agentConf.previewDialing === "ENABLED" && (
                        <SwitchMode
                            checked={checked}
                            handleChange={handleChange}
                        />
                    )}

                {/*props.agentState === "CALL_PROGRESS" && <CallProgressBox selectedValue={{ phone: props.custPhone }} open={open} handleClose={handleClose} />*/}

                
                {/*Gateway selection */}

                {props.campConf?.gw_dialing === "1" && (
                     <Select
                     className={classes.GatewayButton}
                     value={selectedGateway}
                     onChange={handleGatewayChange}
                     displayEmpty
                     renderValue={(selected) => {
                       if (!selected) {
                         return <span >Select Gateway</span>;
                       }
                       return selected.charAt(0).toUpperCase() + selected.slice(1) + " Gateway";
                     }}
                   >
                     <MenuItem value="">
                       Select Gateway
                     </MenuItem>

                     {gatewayList.map((gateway) => (
                       <MenuItem key={gateway} value={gateway}>
                         {/* <ListItemIcon sx={{ minWidth: 30 }}>
                           <FiberManualRecordIcon sx={{ fontSize: 12, color: gatewayColor[gateway] || 'text.secondary' }} />
                         </ListItemIcon> */}
                         <ListItemText primary={`${gateway.charAt(0).toUpperCase() + gateway.slice(1)} Gateway`} />
                       </MenuItem>
                     ))}
                   </Select>
                )}

                {props.agentState !== "CONF" &&
                props.agentState !== "BREAK" &&
                props.agentState !== "READY" ? (
                    <SelectBreak
                        breakReasons={breakReasons}
                        breakType={value}
                        breakClicked={breakClicked}
                        agentState={props.agentState}
                    />
                ) : (
                    <BreakButton
                        agentState={props.agentState}
                        breakLoading={props.breakLoading}
                        applyStyle={classes.BreakButton}
                        handleBreak={handleBreak}
                    />
                )}
                </div>

              
       <div className={classes.iconsParentDiv}>

                {/* ===== This button (toggleSelectsMobile) is just for mobile view ===== */}
                <IconButton
                    color="inherit"
                    className={[classes.headerMenuButton, classes.toggleSelectsMobile].join(
                        " "
                    )}
                    onClick={toggleSelectsParentDiv}
                >
                    <AppsIcon
                        classes={{ root: classes.headerIcon }}
                    />
                </IconButton>
                
                {props.agentState !== "INCALL" &&(
                <IconButton
                    color="inherit"
                    title="Refresh"
                    className={[classes.headerMenuButton, classes.ML20].join(
                        " "
                    )}
                    onClick={handleRefresh}
                >
                    <RefreshIcon
                        fontSize="large"
                        classes={{ root: classes.headerIcon }}
                    />
                </IconButton>
    ) }

                <IconButton
                    color="inherit"
                    title="Notification"
                    aria-haspopup="true"
                    aria-controls="mail-menu"
                    aria-label="Notification"
                    disabled={notifications.length ? false : true}
                    onClick={(e) => {
                        setNotificationsMenu(e.currentTarget);
                        setIsNotificationsUnread(false);
                    }}
                    className={classes.headerMenuButton}
                >
                    <Badge
                        badgeContent={
                            isNotificationsUnread ? notifications.length : 0
                        }
                        color="danger"
                    >
                        {notifications.length ? (
                            <NotificationsIcon
                                fontSize="large"
                                classes={{ root: classes.headerIcon }}
                            />
                        ) : (
                            <NotificationsIcon
                                fontSize="large"
                                classes={{ root: classes.headerDisableIcon }}
                            />
                        )}
                    </Badge>
                </IconButton>
                { props.campConf.call_park === "1" && (
                    <ParkCount value={props.parkDetails} />
                )}
                { props.facilityConf.queue_info !== "1" && (
                    <QueueCount value={props.callsInQueue} />
                )}
                <div
                    className={classes.ML20}
                    onClick={function(e) {
                        setProfileMenu(e.currentTarget);
                    }}
                    style={{ display:"inline-flex",alignItems:"center" }}
                >
                    <Box
                    sx={{display: { xs: "none", sm: "inline-flex" },}}
                        onClick={() => toggleShow(!show)}
                    >
                        <Typography className={classes.ProfileName}>
                            {props.agentName}
                        </Typography>
                        {/*show ? <ExpandMoreIcon style={{ color: "black" }} /> : <ExpandLessIcon style={{ color: "black" }} />*/}
                    </Box>
                    <IconButton
                        aria-haspopup="true"
                        color="inherit"
                        className={classes.headerMenuButton}
                        aria-controls="profile-menu"
                        onClick={(e) => setProfileMenu(e.currentTarget)}
                    >
                        <AccountCircleIcon
                              classes={{ root: classes.headerIcon }}
                        />
                    </IconButton>
                </div>
                {/* ===== This button (toggleSidbarBtn) is just for mobile view ===== */}

                    <IconButton
                    color="inherit"
                    onClick={() => onToggleSidebar(props.isSidebarOpened)} className={classNames(classes.headerMenuButton, classes.toggleSidbarBtn)}>
                    <MenuIcon classes={{ root: classes.headerIcon }}/>
                </IconButton>
                </div>

                <Menu
                    id="notifications-menu"
                    open={Boolean(notificationsMenu)}
                    anchorEl={notificationsMenu}
                    onClose={() => setNotificationsMenu(null)}
                    className={classes.headerMenu}
                    disableAutoFocusItem
                >
                    {notifications.map((notification) => (
                        <MenuItem
                            key={notification.id}
                            onClick={() => setNotificationsMenu(null)}
                            className={classes.headerMenuItem}
                        >
                            <Notification
                                {...notification}
                                typographyVariant="inherit"
                            />
                        </MenuItem>
                    ))}
                </Menu>

                <Menu
                    id="profile-menu"
                    open={Boolean(profileMenu)}
                    anchorEl={profileMenu}
                    onClose={() => setProfileMenu(null)}
                    className={classes.headerMenu}
                    classes={{ paper: classes.profileMenu }}
                    disableAutoFocusItem
                >
                    <div
                        className={classes.profileMenuUser}
                        style={{ paddingLeft: "7px", paddingRight: "15px" }}
                    >
                        <div>
                            <IconButton
                                aria-haspopup="true"
                                color="inherit"
                                className={classes.headerMenuButton}
                                aria-controls="profile-menu"
                            >
                                <AccountCircleIcon
                                    fontSize="large"
                                    style={{
                                        color: "#0c82da",
                                        fontSize: "50px",
                                    }}
                                />
                            </IconButton>
                        </div>
                        <div>
                            <Typography
                                style={{ fontSize: "16px" }}
                                variant="h4"
                                weight="medium"
                            >
                                {props.agentName}
                            </Typography>
                            <Typography
                                style={{ fontSize: "12px", color: "#69728B" }}
                            >
                                Agent ID: {props.agentId}
                            </Typography>
                        </div>
                    </div>
                    <Divider />
                    <div
                        className={classes.profileMenuUser}
                        style={{ paddingLeft: "15px", paddingRight: "15px" }}
                    >
                       
                    </div>
                    <div className={classes.profileMenuUser}>
                        <Typography
                            className={classes.profileMenuLink}
                            onClick={() => {
                                if (
                                    window.confirm(
                                        "Press OK if you want to logout!"
                                    )
                                ) {
                                    signOut(props.history);
                                }
                            }}
                        >
                            <LogOutIcon /> &nbsp; Log Out
                        </Typography>
                    </div>
                </Menu>
            </Toolbar>
            {resetOpen && <PasswordReset 
             agentId={props.agentId} 
        history={props.history} 
        soonExpired={true} 
        open={resetOpen} 
        handleClose={handleClose}  
          />
            }

        </AppBar>
    );
}

const mapStateToProps = (state) => {
    return {
        agentId: state.agentData.agentId,
        callType: state.agentData.callType,
        dialerType: state.agentData.dialerType,
        agentName: state.agentData.agentName,
        mode: state.agentData.dialerType,
        agentState: state.agentData.agentState,
        custPhone: state.agentData.custPhone,
        lastCustPhone: state.agentData.lastCustPhone,
        allowedTime: state.agentData.allowedTime,
        pausedTime: state.agentData.pausedTime,
        breakType: state.agentData.breakType,
        lastActivityTime: state.agentData.lastActivityTime,
        agentInConf: state.agentData.agentInConf,
        callsInQueue: state.agentData.callsInQueue,
        autoReadyTime: state.agentData.autoReadyTime,
        autoReadyFlag: state.agentData.autoReadyFlag,
        previewDialing: state.agentData.previewDialing,
        modeSuccess: state.agentMode.status,
        modeError: state.agentMode.error,
        modeLoading: state.agentMode.loading,
        breakError: state.agentBreak.error,
        breakLoading: state.agentBreak.loading,
        msgs: state.agentNotification.msgs,
        timezones: state.agentConfig.timezone,
        AgentTimezone: state.agentConfig.campConf.agentui_timezone,
        facilityConf: state.agentConfig.facilityConf,
        campConf: state.agentConfig.campConf,
        agentConf: state.agentConfig.agentConf,
        disconnectError: state.agentDisconnect.error,
        disconnectLoading: state.agentDisconnect.loading,
        dialLoading: state.agentDial.loading,
        breakReasons: state.breakReason.breakReasons,
        parkDetails: state.callParking.parkDetails,
        loginType: state.agentData.loginType,
        loading: state.breakReason.loading,
        error: state.breakReason.error,
         isSidebarOpened: state.layout.isSidebarOpened,
         registerstatus: state.agentData.registerstatus,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onModeChange: (agentId, mode, agentState) =>
            dispatch(actions.modeChange(agentId, mode, agentState)),
        onAgentBreak: (agentId, breakState, reason) =>
            dispatch(actions.agentBreak(agentId, breakState, reason)),
        onAgentNotification: (agentId) =>
            dispatch(actions.agentNotification(agentId)),
        onAgentConfig: (agentId) => dispatch(actions.agentConfig(agentId)),
        onGetDisposition: (agentId) =>
            dispatch(actions.getDisposition(agentId)),
        onBreakReason: (agentId) => dispatch(actions.breakReason(agentId)),
        onCallData: (agentId) => dispatch(actions.callData(agentId)),                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                       
        onAgentDisconnect: (agentId, feedbackFlag, callStatus) =>
            dispatch(
                actions.agentDisconnect(agentId, feedbackFlag, callStatus)
            ), 
        onToggle: (isSidebarOpened) => dispatch(actions.toggleSidebar(isSidebarOpened)),                                                                                                                                                                                                               
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);
